namespace RioERP.Masters {
    export interface CurrenciesRow {
        Id?: number;
        Name?: string;
        CurrencyCode?: string;
        InrRate?: number;
        IsActive?: boolean;
        IsDefault?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace CurrenciesRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Masters.Currencies';
        export const lookupKey = 'Masters.Currencies';

        export function getLookup(): Q.Lookup<CurrenciesRow> {
            return Q.getLookup<CurrenciesRow>('Masters.Currencies');
        }
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            CurrencyCode = "CurrencyCode",
            InrRate = "InrRate",
            IsActive = "IsActive",
            IsDefault = "IsDefault",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
